import { vacanciesFormConstants, userConstants } from '../_constants';

const initialState = {
  step: 1,
  step1Data: null,
  isLoading: false,
  isLoading2: false,
  redirectTo: false,

  vacancy: null,
  contact: null,
  profile: null,
};

export function vacanciesForm(state = initialState, action) {
  switch (action.type) {
    case vacanciesFormConstants.VACANCY_DATA:
      return {
        ...state,
        vacancy: action.payload,
      };
    case vacanciesFormConstants.VACANCY_CONTACT_DATA:
      return {
        ...state,
        contact: action.payload,
      };
    case vacanciesFormConstants.VACANCY_PROFILE_DATA:
      return {
        ...state,
        profile: action.payload,
      };
    case vacanciesFormConstants.REDIRECT_TO:
      return {
        ...state,
        redirectTo: action.payload,
      };
    case vacanciesFormConstants.CLEAR_FORM:
      return {
        ...initialState,
      };
    case vacanciesFormConstants.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case vacanciesFormConstants.IS_LOADING2:
      return {
        ...state,
        isLoading2: action.payload,
      };
    case vacanciesFormConstants.GO_TO:
      return {
        ...state,
        step: action.payload,
      };
    case vacanciesFormConstants.UPDATE_DATA_STEP1:
      return {
        ...state,
        step1Data: action.payload,
      };
    case userConstants.LOGOUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
